import AbstractService from '@/services/abstractService'

class PhaseOneService extends AbstractService {
  endpoint = 'projects'

  post(id, data) {
    console.log('dataaa', data)
    // define append form
    const formData = new FormData()
    for (const key in data) {
      if (key === 'designTypes') {
        if (data[key].length === 0) formData.append(`${key}[]`, [])
        for (const index in data[key]) {
          formData.append(`${key}[${index}]`, data[key][index])
        }
      } else {

        if(data[key] != null){
          formData.append(key, data[key])
        }   else {
          formData.append(key, '')

        }
      }
    }
    return this.http.post(`${this.endpoint}/${id}/phase1`, formData)

    // return this.http.post(`${this.endpoint}/${data.id}`, formData)
  }
}

const Service = new PhaseOneService()

export default Service
